<script>
import axios from 'axios';
export default {
  props:{type:{type:String,required:true},uuid:{type:String,required:true}},
  data(){return {url:'',busy:false,error:''};},
  methods:{
    headers(){const user=JSON.parse(localStorage.getItem('user'));return {Accept:'application/json',Authorization:`Bearer ${user.access_token}`};},
    async create(){
      this.busy=true;this.error='';
      try {const {data}=await axios.post(`${process.env.VUE_APP_API}api/v1/admin/billing-access/${this.type}/${this.uuid}`,{}, {headers:this.headers()});this.url=data.data.url;}
      catch(_){this.error='Não foi possível gerar o link.';}finally{this.busy=false;}
    },
    async revoke(){
      if(!window.confirm('Revogar todos os links compartilhados desta consulta?'))return;
      this.busy=true;this.error='';
      try{await axios.delete(`${process.env.VUE_APP_API}api/v1/admin/billing-access/${this.type}/${this.uuid}`,{headers:this.headers()});this.url='';}
      catch(_){this.error='Não foi possível revogar os links.';}finally{this.busy=false;}
    }
  }
};
</script>
<template><div>
  <button class="btn btn-info btn-sm" :disabled="busy" @click="create">Gerar link — 7 dias</button>
  <button class="btn btn-outline-secondary btn-sm" :disabled="busy" @click="revoke">Revogar links</button>
  <div v-if="url"><a :href="url" target="_blank" rel="noreferrer noopener">Abrir consulta</a><input class="form-control" readonly :value="url" @focus="$event.target.select()"><small>Copie o link. Válido por 7 dias.</small></div>
  <small v-if="error" class="text-danger">{{error}}</small>
</div></template>
